/**
 * CenteredStatePanel — Contenido centrado en el área útil (como LoadErrorScreen).
 *
 * QUÉ HACE: Centra vertical y horizontalmente un bloque (icono, título, formulario)
 *           en cualquier resolución dentro del <main>, sin overlay fijo.
 *
 * QUÉ EXPORTA: CenteredStatePanel
 *
 * QUÉ NO DEBE HACER: Lógica de negocio ni llamadas API.
 */

import type { ReactNode } from "react";

export interface CenteredStatePanelProps {
  children: ReactNode;
  /** Ancho máximo del bloque interior (default max-w-sm) */
  maxWidthClass?: string;
  className?: string;
  /**
   * `main` — dentro del <main> (caja cerrada, skeleton). Resta header móvil.
   * `overlay` — pantalla fija a viewport (éxito de venta, estados full-screen).
   */
  scope?: "main" | "overlay";
}

const CenteredStatePanel = ({
  children,
  maxWidthClass = "max-w-sm",
  className = "",
  scope = "main",
}: CenteredStatePanelProps) => {
  const shellClass =
    scope === "overlay"
      ? "flex min-h-[100dvh] w-full flex-col items-center justify-center px-4 py-6 sm:py-8"
      : "app-centered-state flex w-full flex-col items-center justify-center px-4 py-6 sm:py-8";

  return (
    <div className={`${shellClass} ${className}`}>
      <div className={`w-full ${maxWidthClass} mx-auto`}>{children}</div>
    </div>
  );
};

export default CenteredStatePanel;
